<template>
  <empty-layout>
    <div class="w-[100vw] h-[100svh] fixed top-0 left-0 right-0 bottom-0">
      <div
        class="close-btn absolute cursor-pointer z-50 mx-2 md:mx-6 lg:ml-14 pt-2 md:pt-4"
        @click="back"
      >
        <img src="../../../public/assets/icons/go-back-chevron.svg" />
      </div>
      <iframe
        :src="prefilledFormUrl"
        id="JotFormIFrame-250500767303449"
        title="(Registration) GenerationS Implementation Community 2, 3, 4"
        onload="window.parent.scrollTo(0,0)"
        class="w-[100vw] h-[100svh] overflow-auto"
      ></iframe>
    </div>
  </empty-layout>
</template>

<script>
import EmptyLayout from "@/components/EmptyLayout.vue";
import axios from "axios";

export default {
  layout: 'form-empty',
  components: {
    EmptyLayout,
  },
  data() {
    return {
      formValues: {
        DID: 0,
        GID: '',
        FN: '', 
        CH: '',  
        EM: '',  
        CT: '',
        TS: 0,
        // Initialize T1 through T10
      },
      baseFormUrl: 'https://form.jotform.com/250592805393462/'
    }
  },
  async ionViewDidEnter() {
    const tripLeaderStatus = await this.checkTripLeaderStatus();
    if (tripLeaderStatus){
      this.fetchFormValues();
    } else {
      this.$router.push('/whats-next');
    }
  },
  computed: {
    prefilledFormUrl() {
      const params = new URLSearchParams(this.formValues).toString();
      return `${this.baseFormUrl}?${params}`;
    }
  },
  methods: {
    back() {
      this.$router.push('/whats-next');
    },
    async fetchFormValues() {
      try {
        const accessToken = this.$store.state.user.token;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/conference/signup-information/${process.env.VUE_APP_CONFERENCE_ID}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }
        );
        const data = response.data;
        // Map API data to your prefill keys:
        this.formValues.DID = data.delegateId || 0;
        this.formValues.GID = data.signupGroupId || '';
        this.formValues.FN = data.name || '';
        this.formValues.CH = data.organization || '';
        this.formValues.EM = data.email || '';
        this.formValues.CT = data.country || '';
        this.formValues.TS = data.delegateTeammates.length || 0;
        
        // Dynamically assign T1 through T15
        for (let i = 1; i <= data.delegateTeammates.length; i++) {
            this.formValues['T' + i] = data.delegateTeammates[i - 1] 
            ? data.delegateTeammates[i - 1].name 
            : '';
          this.formValues['EM'+i]= data.delegateTeammates[i - 1] 
            ? data.delegateTeammates[i - 1].email 
            : '';
        }
        
        return data;
      } catch (error) {
        console.error("Error fetching signup information:", error);
      }
    },

    async checkTripLeaderStatus() {
      try {
        // Retrieve the access token from your store or authentication service
        const accessToken = this.$store.state.user.token;

        // Make the API call to check the signup status
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/conference/conference-details/${process.env.VUE_APP_CONFERENCE_ID}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        return response.data.isPersonOfContact;
      } catch (error) {
        console.error("Error fetching signup status:", error);
      }
    },
  }
}
</script>
<style scoped>
iframe {
  background-color: transparent;
}

</style>
